import React, { useState, useEffect, useRef } from 'react';
import { func, string, bool } from 'prop-types';
import {
  params,
  string as stringType,
  useLazyDataModel
} from '@thd-nucleus/data-sources';
import { Image, Button } from '@thd-olt-component-react/core-ui';
import styles from './create-a-list-form.module.scss';
import { getValidationError, LIST_SHAPE, triggerAnalytics } from '../helpers';
import { NameField } from '../name-field/name-field';
import { LIST_CREATE_WO_PRODUCTS } from '../constants';

export const CreateAListForm = (props) => {

  const {
    showCancelbtn, buttonText, header, onClose, onCreate
  } = props;

  useEffect(() => {
    LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('create-a-list-form.ready');
  }, []);
  const [name, setName] = useState('');
  const [error, setError] = useState(null);
  const listForm = useRef();

  const [submitCreateListForm] = useLazyDataModel('createList', {
    variables: {
      name
    },
    context: { withAuth: true }
  });

  const handleSubmit = async (evt) => {
    evt.preventDefault();
    const { error: nameError } = getValidationError({ value: name });
    if (!nameError) {
      const { data, errors } = await submitCreateListForm({
        variables: { name }
      });
      if (data?.createList && !errors) {
        triggerAnalytics(LIST_CREATE_WO_PRODUCTS, {});
        onCreate(data?.createList);
      } else if (errors) {
        setError({ message: errors[0]?.message, name });
      }
    }
  };

  const onNameChange = ({ value: fieldValue }) => {
    if (error && fieldValue !== error.name) {
      setError(null);
    }
    const { error: fieldError } = getValidationError({ value: fieldValue });
    setName(fieldValue);
    // hack, I hate the Input
    if (fieldError) {
      setError({
        message: fieldError,
        name: fieldValue
      });
    }
  };

  return (
    <form
      className={styles['create-a-list-form']}
      onSubmit={handleSubmit}
      data-testid="create-a-list-form"
      ref={listForm}
    >
      <div className={styles['create-a-list-form__header']}>
        <h2>{header}</h2>
        {showCancelbtn && (
          <button onClick={onClose} type="button">
            <Image height={20} width={20} asset="close-symbol-orange.svg" alt="Close" />
          </button>
        )}
      </div>
      <div className={styles['create-a-list-form__sub-header__container']}>
        <Image
          alt="lock-icon"
          src="https://assets.homedepot-static.com/images/v1/lock-icon-orange.svg"
        />
        <span className={styles['create-a-list-form__sub-header__message']}>
          Your list can only be seen by you or people you share it with
        </span>
      </div>
      <NameField onValidation={onNameChange} error={error?.message} />
      <div className={styles['create-a-list-form__footer']}>
        <Button
          type="submit"
          disabled={!name || !!error?.message}
        >
          {buttonText}
        </Button>
      </div>
    </form>
  );
};

CreateAListForm.propTypes = {
  // text for the submit button
  buttonText: string,
  // adds a close button to the header and calls the method if passed in
  onClose: func,
  // callback when user clicks the form button, return parameters: { name, isPrivate }
  onCreate: func.isRequired,
  showCancelbtn: bool,
  // list form header
  header: string,
};

CreateAListForm.defaultProps = {
  buttonText: 'Create',
  showCancelbtn: false,
  header: 'Create A List',
  onClose: () => {},
};

CreateAListForm.displayName = 'CreateAListForm';

CreateAListForm.dataModel = {
  createList: params({
    name: stringType().isRequired()
  }).mutation().shape(LIST_SHAPE)
};
